export type Address = {
  address: string;
  postalCode: string;
  city: string;
  latitude?: number;
  longitude?: number;
};

export function getAddressDetails(place: google.maps.places.Place): Address {
  const city = place.addressComponents?.find((comp) => comp.types.includes("postal_town")
  )?.longText;
  const postalCode = place.addressComponents?.find((comp) => comp.types.includes("postal_code")
  )?.longText;
  const street = place.addressComponents?.find((comp) => comp.types.includes("route"))?.longText;
  const streetNumber = place.addressComponents?.find((comp) => comp.types.includes("street_number")
  )?.longText;
  const latitude = place.location?.lat();
  const longitude = place.location?.lng();

  return {
    city: city || "",
    postalCode: postalCode || "",
    address: [street, streetNumber].filter(Boolean).join(" "),
    latitude,
    longitude,
  };
}
